import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Mon Oct 08 2018
 * @author SKu
 * @author BPo
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { jsonConversions, SiteReleaseUploadConverter, SiteReleaseConverter, SiteReleaseItemConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var SiteReleaseLayer =
/*#__PURE__*/
function () {
  function SiteReleaseLayer() {
    _classCallCheck(this, SiteReleaseLayer);
  }

  _createClass(SiteReleaseLayer, [{
    key: "uploadRegularSiteRelease",

    /*******************************************SITE RELEASE ENDPOINTS**************************************************************/

    /**
     * Create regular site release.
     * @param Name Release name
     * @param file upload file
     * @param description release description
     * @returns ProductPricesUpload with progress monitor id
     */
    value: function uploadRegularSiteRelease(file, name, description) {
      var _this = this;

      var data = new FormData();
      data.append('file', file.data);
      data.append('name', name);

      if (description) {
        data.append('description', description);
      }

      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_UPLOAD_FILE).post(data, {
        responseType: 'json'
      }).then(function (response) {
        return _this.siteReleaseUploadConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getRegularSiteReleaseUpload",
    value: function getRegularSiteReleaseUpload(id) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_UPLOAD_ID(id)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this2.siteReleaseUploadConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getSiteRelease",
    value: function getSiteRelease(id) {
      var _this3 = this;

      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_ID(id)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this3.siteReleaseConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getSiteReleaseItems",
    value: function getSiteReleaseItems(id) {
      var _this4 = this;

      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_ID_ITEM(id)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this4.siteReleaseItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "confirmSiteReleaseExport",
    value: function confirmSiteReleaseExport(id) {
      var _this5 = this;

      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_ID_EXPORT_CONFIRMATION(id)).post({}, {
        responseType: 'json'
      }).then(function (response) {
        return _this5.siteReleaseConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "cancelSiteRelease",
    value: function cancelSiteRelease(terminationId) {
      var _this6 = this;

      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_ID_CANCELLATION(terminationId)).patch({}, {
        responseType: 'json'
      }).then(function (response) {
        return _this6.siteReleaseConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateReleaseItemExported",
    value: function updateReleaseItemExported(data) {
      var _this7 = this;

      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_ITEMS_EXPORTED).patch({
        data: data
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this7.siteReleaseItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateReleaseItemValidFrom",
    value: function updateReleaseItemValidFrom(data) {
      var _this8 = this;

      var parsedData = [];
      data.forEach(function (d) {
        return parsedData.push({
          id: d.id,
          validFrom: d.validFrom.format('YYYY-MM-DD')
        });
      });
      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_ITEMS_PRICE_VALID_FROM).patch({
        data: [].concat(parsedData)
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this8.siteReleaseItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateReleaseItemPriceValue",
    value: function updateReleaseItemPriceValue(data) {
      var _this9 = this;

      return api(CONSTANTS.API.ENDPOINTS.SITE_RELEASE_ITEMS_PRICE_VALUE).patch({
        data: data
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this9.siteReleaseItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return SiteReleaseLayer;
}();

__decorate([Inject, __metadata("design:type", SiteReleaseUploadConverter)], SiteReleaseLayer.prototype, "siteReleaseUploadConverter", void 0);

__decorate([Inject, __metadata("design:type", SiteReleaseConverter)], SiteReleaseLayer.prototype, "siteReleaseConverter", void 0);

__decorate([Inject, __metadata("design:type", SiteReleaseItemConverter)], SiteReleaseLayer.prototype, "siteReleaseItemConverter", void 0);